import { formatNumberForDisplay } from '@/common';

export const formatStatCount = (value?: number | null): string =>
  value == null ? '—' : formatNumberForDisplay(value);
